(function() {
  document.addEventListener('DOMContentLoaded', function() {
    
    /* 1. Thumbnail Switcher & Lightbox */
    var mainImg = document.getElementById('pdpMainImg');
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var lightbox = document.getElementById('pdpLightbox');
    var lightboxImg = document.getElementById('pdpLightboxImg');
    var lightboxClose = document.getElementById('pdpLightboxClose');

    thumbs.forEach(function(t) {
      t.addEventListener('click', function() {
        thumbs.forEach(function(item) { item.classList.remove('active'); });
        t.classList.add('active');
        var newSrc = t.dataset.src;
        if (mainImg && newSrc) {
          mainImg.src = newSrc;
        }
      });
    });

    if (mainImg && lightbox && lightboxImg) {
      mainImg.addEventListener('click', function() {
        lightboxImg.src = mainImg.src;
        lightbox.classList.add('active');
      });
    }

    if (lightboxClose && lightbox) {
      lightboxClose.addEventListener('click', function() {
        lightbox.classList.remove('active');
      });
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) lightbox.classList.remove('active');
      });
    }

    /* 2. Pack Tier Selector (1-Pack CHF 69 vs 3-Pack CHF 159) */
    var packOptions = document.querySelectorAll('.pdp-pack-option');
    var priceDisplay = document.getElementById('pdpPriceCurrent');
    var priceCompare = document.getElementById('pdpPriceCompare');
    var selectedPack = 1;

    packOptions.forEach(function(opt) {
      opt.addEventListener('click', function() {
        packOptions.forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        selectedPack = parseInt(opt.dataset.pack, 10) || 1;

        if (priceDisplay) {
          priceDisplay.textContent = (selectedPack === 3) ? 'CHF 159.–' : 'CHF 69.–';
        }
        if (priceCompare) {
          priceCompare.style.display = (selectedPack === 3) ? 'inline' : 'none';
        }
        var addBtnEl = document.getElementById('pdpAddBtn');
        if (addBtnEl) {
          addBtnEl.innerHTML = (selectedPack === 3) 
            ? '<span>In den Warenkorb – CHF 159.–</span>' 
            : '<span>In den Warenkorb – CHF 69.–</span>';
        }
      });
    });

    /* 3. Quantity Controls */
    var qtyVal = document.getElementById('pdpQtyVal');
    var btnMinus = document.getElementById('pdpQtyMinus');
    var btnPlus = document.getElementById('pdpQtyPlus');
    var currentQty = 1;

    if (btnMinus && btnPlus && qtyVal) {
      btnMinus.addEventListener('click', function() {
        if (currentQty > 1) {
          currentQty--;
          qtyVal.textContent = currentQty;
        }
      });
      btnPlus.addEventListener('click', function() {
        currentQty++;
        qtyVal.textContent = currentQty;
      });
    }

    /* 4. Accordions */
    var accordionHeads = document.querySelectorAll('.pdp-accordion-head');
    accordionHeads.forEach(function(head) {
      head.addEventListener('click', function() {
        var item = head.closest('.pdp-accordion-item');
        if (item) {
          item.classList.toggle('open');
        }
      });
    });

    /* 5. Add to Cart AJAX Handler */
    var addBtn = document.getElementById('pdpAddBtn');
    if (addBtn) {
      addBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var settings = window.NUQO_PRODUCT_SETTINGS || {};
        var variantId = (selectedPack === 3) 
          ? (settings.variant_id_3 || settings.variant_id_1) 
          : settings.variant_id_1;

        var actualQty = currentQty;

        function executeAdd(vId, qVal) {
          var is3Pack = (selectedPack === 3);
          var finalQty = is3Pack ? (qVal * 3) : qVal;
          var itemPayload = { id: vId, quantity: finalQty };
          if (is3Pack) {
            itemPayload.properties = { 'Set': '3-Pack Reiseset (CHF 159.–)', '_bundle_price': '159.00' };
          }
          fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [itemPayload] })
          })
          .then(function(res) { return res.json(); })
          .then(function(data) {
            addBtn.disabled = false;
            addBtn.innerHTML = '<span>Added to Cart! ✓</span>';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function() {
              var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/');
              var redirectUrl = is3Pack ? (root + 'discount/3PACK159?redirect=/cart') : (root + 'cart');
              window.location.href = redirectUrl;
            }, 400);
          })
          .catch(function(err) {
            console.error('Cart add error:', err);
            addBtn.disabled = false;
            addBtn.innerHTML = origText;
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
          });
        }

        if (!variantId) {
          var pUrl = window.location.pathname.endsWith('.js') ? window.location.pathname : window.location.pathname + '.js';
          fetch(pUrl)
            .then(function(r) { return r.json(); })
            .then(function(pData) {
              var fetchedVarId = (pData && pData.variants && pData.variants[0]) ? pData.variants[0].id : null;
              if (fetchedVarId) {
                executeAdd(fetchedVarId, actualQty);
              } else {
                fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'products.json?limit=1')
                  .then(function(r2) { return r2.json(); })
                  .then(function(pj) {
                    var fallbackId = (pj && pj.products && pj.products[0] && pj.products[0].variants[0]) ? pj.products[0].variants[0].id : null;
                    if (fallbackId) executeAdd(fallbackId, actualQty);
                    else window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
                  });
              }
            })
            .catch(function() {
              window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
            });
          return;
        } else {
          executeAdd(variantId, actualQty);
          return;
        }

        addBtn.disabled = true;
        var origText = addBtn.innerHTML;
        addBtn.innerHTML = '<span>Adding...</span>';

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: actualQty }] })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          addBtn.disabled = false;
          addBtn.innerHTML = '<span>Added to Cart! ✓</span>';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function() {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
          }, 400);
        })
        .catch(function(err) {
          console.error('Cart add error:', err);
          addBtn.disabled = false;
          addBtn.innerHTML = origText;
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
        });
      });
    }

  });
})();
